import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { mypage_url, loan_types } from '../Const';
import Popup from '../molecules/Popup';
import {
  KWANKGM04270A01,
  KWANKGM04270A02_Validate,
  KWANKGM04270A02_Autodisplay,
  KWANKGM04240A01,
  KWANKGM04240A02_Validate,
  KWANKGM04240A02_Autodisplay,
} from '../const/api_modules';

interface Props {
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  status_code: number;
  tempSave: (module_name: string) => Promise<any>;
  validate: (module_name: string) => Promise<any>;
  moveNextStep: () => void;
  is_implement_online_identification?: boolean;
  requestModuleAutodisplay: (autodisplay_module: string) => void;
}

// KWANKGM04220_借入申込希望書兼経営改善資金計画書_入力
// KWANKGM04260_近代化資金借入申込書_入力
const FooterExaminationApplicantInputModernizationFunds: React.FC<Props> = ({
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  tempSave,
  validate,
  moveNextStep,
  is_implement_online_identification,
  requestModuleAutodisplay,
}) => {
  const [modal_temp_save, setModalTempSave] = useState(false);
  const history = useHistory();

  const url = new URL(window.location.href);
  const item_id = url.searchParams.get('item_id');

  /**
   * ナビゲーションを次に遷移
   * 下記画面に遷移
   *
   * KWANKGM04230_借入申込希望書兼経営改善資金計画書　書類提出
   * KWANKGM04230_近代化資金借入申込 書類提出
   */
  const handleClickNext = async() => {
    // 商品によって、「次へ進む」のモジュールを切り替える
    const module_name = item_id === loan_types.modernization_funds ? KWANKGM04270A02_Validate : KWANKGM04240A02_Validate;
    const autodisplay_module = item_id === loan_types.modernization_funds ? KWANKGM04270A02_Autodisplay : KWANKGM04240A02_Autodisplay;
    const run_autodisplay = await requestModuleAutodisplay(autodisplay_module);
    const result = await validate(module_name);

      if (result) {
        moveNextStep();
        history.push({
          pathname: `/reception/${reception_cd}/${reception_id}/${status_code}/upload`,
          search: `?item_id=${item_id}`,
        });
    };
  }
  /**
   * 一時保存する押下時アクション
   */
  const handleClickOpenTempSave = async() => {

    // 商品によって、「一時保存をする」モジュールを切り替える
    const module_name = item_id === loan_types.modernization_funds ? KWANKGM04270A01 : KWANKGM04240A01;
    const result = await tempSave(module_name);

      if (result) {
        setModalTempSave(true);
      }
  };

  /**
   * 次へ進むボタンを表示する
   */
  const displayNextButton = () =>{
    if(item_id === null){
        return null;
    }

    if(item_id === loan_types.modernization_funds){
      return(
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
        <div className="text-right sp-button-center">
          <a
            className={`btn btn-xl btn-main-color sp-btn-height ml-auto ${is_implement_online_identification &&
              'disabled-bg'} `}
            onClick={handleClickNext}
          >
            次へ進む
          </a>
        </div>
      </Col>
      )
    } else if(item_id === loan_types.business_improvement_financing_plan) {
      return(
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
          <div className="text-right sp-button-center">
            <a
              className={"btn btn-xl btn-main-color sp-btn-height ml-auto"}
              onClick={handleClickNext}
              >
              次へ進む
            </a>
          </div>
        </Col>
      )
   }
  }

  return (
    <>
      <Row className="mt-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-no-arrow">
          <div className="text-left sp-button-center">
            <a className="btn btn-xl btn-main-color " onClick={handleClickOpenTempSave}>
              一時保存する
            </a>
          </div>
        </Col>
        {displayNextButton()}
      </Row>
      <Popup
        title="一時保存完了"
        text="入力内容を一時保存しました。このまま入力を続けますか？"
        first_button={{
          label: '入力を続ける',
          variant: 'success',
          handleClick: () => setModalTempSave(false),
        }}
        second_button={{
          label: 'マイページへ戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalTempSave(false);
            location.href = mypage_url;
          },
        }}
        toggleClose={() => setModalTempSave(false)}
        toggleShow={modal_temp_save}
      />
    </>
  );
};

export default memo(FooterExaminationApplicantInputModernizationFunds);
